
export const Signed = "Signed"
export const MarkedAsAgreed = "Marked as agreed"
export const SignatureRequest = "Signature requested"
export const NotSigned = "Not signed"
